import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { IconFileExport } from '@tabler/icons-react';

import { coursesAnalyticsActions } from 'pages/insights/containers/coursesAnalyticsContainer/actions';

const DownloadCoursesAnalytics = (props) => {
  const handleFilterChange = () => {
    props.dispatch(coursesAnalyticsActions.fetchInsightsCoursesCSV());
  };

  return (
    <div id="export_button">
      <Button variant="outline-primary" onClick={handleFilterChange}>
        Export <span className="d-none-md">CSV</span>
        <IconFileExport className="ms-2" stroke={1.5} />
      </Button>
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default connect(null, mapDispatchToProps)(DownloadCoursesAnalytics);
